import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Extent extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.extent',
        group: 'Spatial Constructors',
        title: 'ST Extent',
        description: `
      Creates a new table containing the bounding box of the input table.
      `,
        starred: true
      },
      [
        {
          name: 'table',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'table',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT ST_GEOGFROMTEXT(CONCAT('POLYGON((', bbox.xmin, ' ', bbox.ymin, ', ', bbox.xmin, ' ', bbox.ymax, ', ',
                bbox.xmax, ' ', bbox.ymax, ', ', bbox.xmax, ' ', bbox.ymin, ', ',
                bbox.xmin, ' ', bbox.ymin, '))')) AS geom
            FROM (
              SELECT ST_EXTENT(${params.geo}) bbox
              FROM \`${params.table}\`
            )`
      case Provider.Snowflake:
      case Provider.Redshift:
        return dedent`SELECT ST_ENVELOPE(ST_COLLECT(${params.geo})) geom
                FROM ${params.table}`
      case Provider.Postgres:
        return dedent`SELECT ST_EXTENT(${params.geo})::geometry geom
                FROM ${params.table}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, geom) */
                  SEDONA_ST_ASBINARY(SEDONA_ST_ENVELOPE(SEDONA_ST_COLLECT(SEDONA_ST_GEOMFROMWKB(${params.geo})))) geom
                FROM ${params.table}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ connection }: GetOutputSchemaParams): TableSchema {
    return [
      {
        name: 'geom',
        type: connection.getGeoDataType()
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { Extent }
